/**
 * RG Value Prop - Comparison Slider Logic
 */

class RGCompareSlider {
    constructor(container) {
        this.container = container;
        this.input = container.querySelector('[data-rg-compare-input]');
        this.overlay = container.querySelector('[data-rg-compare-overlay]');
        this.handle = container.querySelector('[data-rg-compare-handle]');
        this.afterImage = container.querySelector('.rg-compare__image--after');

        this.init();
    }

    init() {
        this.initDeferredImages();

        if (!this.input || !this.overlay || !this.handle) return;

        // Sync input change
        this.input.addEventListener('input', (e) => this.update(e.target.value));

        // Initial update
        this.update(this.input.value);

        // Resize observer to fix image width in overlay
        const resizeObserver = new ResizeObserver(() => {
            this.fixImageWidth();
        });
        resizeObserver.observe(this.container);
        this.fixImageWidth(); // Initial fix
    }

    initDeferredImages() {
        const images = this.container.querySelectorAll('[data-rg-deferred-image][data-src]');
        if (!images.length) return;

        const loadImages = () => {
            images.forEach((image) => {
                if (!image.dataset.src) return;
                image.src = image.dataset.src;
                image.removeAttribute('data-src');
            });
        };

        if (!('IntersectionObserver' in window)) {
            loadImages();
            return;
        }

        const observer = new IntersectionObserver((entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            loadImages();
            observer.disconnect();
        }, { rootMargin: '0px', threshold: 0.01 });

        observer.observe(this.container);
    }

    update(value) {
        // Update overlay width
        this.overlay.style.width = `${value}%`;

        // Update handle position
        this.handle.style.left = `${value}%`;
    }

    fixImageWidth() {
        if (this.afterImage) {
            // Force the inner image to match the full container width
            // This prevents it from shrinking when the overlay shrinks
            this.afterImage.style.width = `${this.container.offsetWidth}px`;
        }
    }
}

// Buy Now Logic
class RGBuyNow {
    constructor(container) {
        this.btn = container.querySelector('[data-buy-now]');
        if (this.btn) {
            this.variantId = this.btn.dataset.buyNow;
            this.init();
        }
    }

    init() {
        this.btn.addEventListener('click', (e) => this.handleClick(e));
    }

    async handleClick(e) {
        e.preventDefault();
        const btn = this.btn;

        // Loading State
        const originalText = btn.textContent;
        btn.textContent = 'Procesando...';
        btn.style.pointerEvents = 'none';
        btn.style.opacity = '0.7';

        try {
            const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    id: this.variantId,
                    quantity: 1
                })
            });

            if (response.ok) {
                // Redirect to checkout
                window.location.href = '/checkout';
            } else {
                console.error('Failed to add to cart');
                btn.textContent = 'Error';
                setTimeout(() => {
                    btn.textContent = originalText;
                    btn.style.pointerEvents = 'auto';
                    btn.style.opacity = '1';
                }, 2000);
            }
        } catch (error) {
            console.error('Error:', error);
            btn.textContent = 'Error';
            setTimeout(() => {
                btn.textContent = originalText;
                btn.style.pointerEvents = 'auto';
                btn.style.opacity = '1';
            }, 2000);
        }
    }
}

// Initialize
document.addEventListener('DOMContentLoaded', () => {
    // Sliders
    const sliders = document.querySelectorAll('[data-rg-compare]');
    sliders.forEach(slider => new RGCompareSlider(slider));

    // Buy Now Buttons (Scope to section ideally, but global select also works)
    const sections = document.querySelectorAll('.rg-value-prop');
    sections.forEach(section => new RGBuyNow(section));
});

// Shopify Design Mode
if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
        const slider = event.target.querySelector('[data-rg-compare]');
        if (slider) new RGCompareSlider(slider);

        // Init Buy Now for reloaded section
        const section = event.target.querySelector('.rg-value-prop') || event.target;
        if (section.classList.contains('rg-value-prop')) {
            new RGBuyNow(section);
        }
    });
}
